import { IThemeSlotRule } from './IThemeSlotRule';

export interface IThemeRules {
  [key: string]: IThemeSlotRule;
}